import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: null,
  loading: false,
  error: null,
};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    fetchUserStart(state) {
      state.loading = false;
      state.error = null;
    },
    fetchUserSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchUserFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetUser(state) {
      state.user = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { fetchUserStart, fetchUserSuccess, fetchUserFailure, resetUser } =
  userDetailsSlice.actions;

export default userDetailsSlice.reducer;
